import { useTranslation } from 'react-i18next';
import { CreateUserResourceFormT } from 'shared/form-values/user-resources';
import { useGetResources } from 'shared/api/requests/resources';
import { OneResourceT } from 'shared/api/types/resources';
import Field from 'shared/components/form/Field';
import { useGetUsers } from 'shared/api/requests/users';

import { useFormContext } from 'react-hook-form';
import { Box } from '@chakra-ui/react';
import { ResourceSelectLabel } from "../../components/ResourceSelectLabel";

const UserResourceForm = () => {
  const { t } = useTranslation();
  const {
    setValue,
  } = useFormContext<CreateUserResourceFormT>();

  const fieldProps = {
    mb: '20px',
    w: {
      base: '100%',
      md: '50%',
    },
  };


  return (
    <>
      <Box mb="20px">
        <Field
          type="async-select"
          name="resourceId"
          label={t('links.table.resource')}
          placeholder={t('links.table.resource')}
          optionsQuery={useGetResources}
          onChange={(option: OneResourceT['response']) => setValue('resourceType', option?.resource?.type)}
          renderOptionLabel={(option ) => {
            const optionData = option as OneResourceT['response'];
            return <ResourceSelectLabel resourceName={optionData.resource.name} resourceType={optionData.resource.type}/>
          }}
          labelName="resource.name"
          valueName="resource.id"
          defaultValue={null}
          required
          {...fieldProps}
        />
      </Box>
      <Field
        type="async-select"
        name="userId"
        label={t('users.user')}
        required
        placeholder={t('users.user')}
        optionsQuery={useGetUsers}
        labelName="name"
        valueName="id"
        defaultValue={null}
        {...fieldProps}
      />
    </>
  );
};

export default UserResourceForm;
